import { useEffect } from "react"
import { updateParentTitle } from "@/lib/app-messaging"

/**
 * Custom hook to manage page titles both locally and for parent window
 * @param title - The title to set for the page
 */
export function usePageTitle(title: string) {
  useEffect(() => {
    if (!title) return

    // Set the document title for this app
    if (typeof document !== "undefined") {
      document.title = title
    }

    // Send title update to parent window if we're in an iframe
    if (typeof window !== "undefined" && window.parent && window.parent !== window) {
      updateParentTitle(title)
    }
  }, [title])
}
